import React from 'react';

interface LoadingThinkingIconProps {
  width?: number;
  height?: number;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  className?: string;
  [x: string]: unknown;
}

const LoadingThinkingIcon: React.FC<LoadingThinkingIconProps> = ({
  width = 45,
  height = 45,
  primaryColor = '#22BBE8',
  secondaryColor = '#185A77',
  tertiaryColor = '#1B7A9D',
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <defs>
        <linearGradient id="shine-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="transparent" stopOpacity="0" />
          <stop offset="50%" stopColor="white" stopOpacity="0.6" />
          <stop offset="100%" stopColor="transparent" stopOpacity="0" />
        </linearGradient>
        <mask id="shine-mask">
          <rect width="100%" height="100%" fill="url(#shine-gradient)" />
        </mask>
      </defs>
      <g className="loading-icon-group">
        <path
          d="M15.3164 24.3466C18.7441 24.3466 22.1718 20.9189 22.1718 17.4912C22.1718 20.9189 25.5995 24.3466 29.0271 24.3466C25.5995 24.3466 22.1718 27.7743 22.1718 31.202C22.1718 27.7743 18.7441 24.3466 15.3164 24.3466Z"
          fill={primaryColor}
          stroke={primaryColor}
          strokeWidth="1.13921"
          strokeLinejoin="round"
          className="shine-path"
        />
        <path
          d="M27 17.7168C31.5265 17.7168 33.5 15.8123 33.5 11.2168C33.5 15.8123 35.4597 17.7168 40 17.7168C35.4597 17.7168 33.5 19.6765 33.5 24.2168C33.5 19.6765 31.5265 17.7168 27 17.7168Z"
          fill={secondaryColor}
          className="shine-path"
        />
        <path
          d="M8 15.7832C10.7856 15.7832 12 14.6112 12 11.7832C12 14.6112 13.2059 15.7832 16 15.7832C13.2059 15.7832 12 16.9892 12 19.7832C12 16.9892 10.7856 15.7832 8 15.7832Z"
          fill={tertiaryColor}
          className="shine-path"
        />
        <path
          d="M11 34.7832C13.7856 34.7832 15 33.6112 15 30.7832C15 33.6112 16.2059 34.7832 19 34.7832C16.2059 34.7832 15 35.9892 15 38.7832C15 35.9892 13.7856 34.7832 11 34.7832Z"
          fill={primaryColor}
          className="shine-path"
        />
      </g>
    </svg>
  );
};

export default LoadingThinkingIcon;
